import React, { useEffect, useState } from "react";
import { getCompanyInfo, getNavLinks } from "../api/companyService";
import { sleep } from "../utils/sleep";
import { Link, useLocation } from 'react-router-dom';

 //fallback menu (in case of API error)
  const fallbackNavLinks = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Projects", path: "/projects" },
    { label: "Contact", path: "/contact" },
  ];

const Header = () => {
  const location = useLocation();
  const currentPath = location.pathname.includes("/projects/")
  ? "/projects"
  : location.pathname;

  const [navLinks, setNavLinks] = useState([]);
const [navLoading, setNavLoading] = useState(true);
const [navError, setNavError] = useState(null);

const [companyInfo, setCompanyInfo] = useState(null);
const [companyLoading, setCompanyLoading] = useState(true);
  const [companyError, setCompanyError] = useState(null);
  
          
  useEffect(() => {
  const fetchNavLinks = async () => {
    try {
      //await sleep(2000);
      const data = await getNavLinks();
      setNavLinks(data);
    } catch (err) {
      setNavError("Failed to load nav links.");
    } finally {
      setNavLoading(false);
    }
  };

  const fetchCompanyInfo = async () => {
    try {
      //await sleep(1000);
      const data = await getCompanyInfo(); // new API
      setCompanyInfo(data);
    } catch (err) {
      setCompanyError("Failed to load company info.");
    } finally {
      setCompanyLoading(false);
    }
  };

  fetchNavLinks();
  fetchCompanyInfo();
  }, []);
  
  // Auto-close burger menu when route changes
  useEffect(() => {
  const nav = document.getElementById("navbarNav");
  if (nav?.classList.contains("show")) {
    nav.classList.remove("show");
  }
}, [location]);


  return (
    <nav className="navbar navbar-expand-lg sticky-top" style={{ backgroundColor: 'var(--secondary-color)' }}>
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          
          {(companyLoading || companyError)? (
            <div
        className="placeholder-glow me-2 logo-placeholder"></div>
          ) : (
            <img
            src={require(`../assets/${companyInfo.logo}`)}
            alt={companyInfo.name}
            height="60"
            className="me-2"
          />
          )}
          {(companyLoading || companyError)? (
            <span className="placeholder-glow">
              <span className="placeholder col-4 nav-placeholder">&nbsp;</span>
            </span>
          ) : (
              <span className="text-primary-color fw-bold" style={{ fontSize: "2rem" }}>{companyInfo.name}</span>
          )}
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon" style={{ filter: 'invert(1)' }}></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {((navError || navLoading)? fallbackNavLinks : navLinks).map((link, idx) => {
              const isActive = currentPath === link.path.toLowerCase();
              return (
                <li className="nav-item" key={idx}>
                    {(navLoading || navError) ? (
                      <span className="placeholder-glow">
                        <span className="placeholder col-6 nav-placeholder"> &nbsp;</span>
                      </span>
                    ) : (
                      <Link
                    className={`nav-link custom-link ${isActive ? 'active-link' : ''}`}
                    to={link.path}
                      >{link.label}</Link>
                    )}
                  
                </li>
              );
            })}
          </ul>
        </div>

      </div>
    </nav>
  );
};

export default Header;
